import React from 'react';
import { ShuffleIcon, EyeIcon, HashIcon, LockIcon } from 'lucide-react';
import { Band } from './Band';
import { archetypes } from '../../data/site';
const safeguards = [{
  icon: ShuffleIcon,
  text: 'Which archetypes fire is randomised per instance'
}, {
  icon: EyeIcon,
  text: 'Decoy anomalies resolve legitimately'
}, {
  icon: HashIcon,
  text: 'Defect count varies inside a version'
}, {
  icon: LockIcon,
  text: 'A requisition pins one version until close'
}];
export function Library() {
  return <Band id="library" eyebrow="The scenario library" title="Scenarios are generated by code, not written by hand." description="Each injector emits the constructed files and a machine-readable answer key at the same moment. That is what makes a judgement reconstructable months later. These archetypes are the construction primitives, not the four scenario classes — a single class can be built from several of them, and clean cases use the same generator with nothing mutated." data-id="element-228" data-mp="3vur6ifwyob9h">
      <div className="grid gap-4 lg:grid-cols-[1.4fr_0.6fr] lg:items-start" data-id="element-229" data-mp="s5n0ar5wdn6a">
        <div className="overflow-hidden rounded-2xl border border-mist bg-white/70" data-id="element-230" data-mp="s3k1bhmrojpf">
          <table className="w-full border-collapse text-left" data-id="element-231" data-mp="n4pbvwuanwwc">
            <caption className="sr-only" data-id="element-232" data-mp="11wrehonr1402">Defect archetype library</caption>
            <tbody data-id="element-233" data-mp="x4g4tu37i3ub">
              {archetypes.map(row => <tr key={row.id} className="block border-b border-mist/70 last:border-0 sm:table-row" data-id="element-234" data-mp="x3olpiqspykx">
                  <th scope="row" className="block break-words px-5 pt-4 text-left align-top font-mono text-[13px] font-medium text-teal sm:table-cell sm:w-2/5 sm:px-6 sm:py-4" data-id="element-235" data-mp="1aujnyc6shhfj">
                    {row.id}
                  </th>
                  <td className="block px-5 pb-4 pt-1 align-top text-[15px] leading-snug text-graphite sm:table-cell sm:px-6 sm:py-4" data-id="element-236" data-mp="1fvhcr7mb19q0">
                    {row.behaviour}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <ul className="grid gap-3" data-id="element-237" data-mp="3hoos2h1x3rbw">
          {safeguards.map(item => <li key={item.text} className="flex items-start gap-3 rounded-xl border border-mist bg-white/60 p-4" data-id="element-238" data-mp="b6dhma05uyjy">
              <item.icon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-239" data-mp="f88jpgpx1fys" />
              <span className="text-[15px] leading-snug text-ink" data-id="element-240" data-mp="k58mnirgy2lo">{item.text}</span>
            </li>)}
        </ul>
      </div>
    </Band>;
}